import React from 'react'
import * as S from './AtmosphericHero.elements';
import Heading from "../../components/Heading/Heading";
import Text from "../../components/Text/Text";
import cases1 from "../../assets/img/blocks/atmosphericHero/cases1.jpeg";
import cases2 from "../../assets/img/blocks/atmosphericHero/cases2.jpeg";
import cases3 from "../../assets/img/blocks/atmosphericHero/cases3.jpeg";
import blogs1 from "../../assets/img/blocks/atmosphericHero/blogs1.jpg";
import blogs2 from "../../assets/img/blocks/atmosphericHero/blogs2.jpeg";
import blogs3 from "../../assets/img/blocks/atmosphericHero/blogs3.jpg";
import blogs4 from "../../assets/img/blocks/atmosphericHero/blogs4.jpg";
import blogs5 from "../../assets/img/blocks/atmosphericHero/blogs5.jpeg";
import blogs6 from "../../assets/img/blocks/atmosphericHero/blogs6.jpeg";
import blogs7 from "../../assets/img/blocks/atmosphericHero/blogs7.jpeg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const AtmosphericHero = ({title, text, location}) => {

    const blogsAndLabsSlides = [
        {"id": 1, "image": blogs1},
        {"id": 2, "image": blogs2},
        {"id": 3, "image": blogs3},
        {"id": 4, "image": blogs4},
        {"id": 5, "image": blogs5},
        {"id": 6, "image": blogs6},
        {"id": 7, "image": blogs7},
    ];

    const casesSlides = [
        {"id": 1, "image": cases1},
        {"id": 2, "image": cases2},
        {"id": 3, "image": cases3},
    ];

    const data = location === "blogs" ? blogsAndLabsSlides : casesSlides;

    const settings = {
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: true,
    };

    return (
        <S.StyledAtmosphericHero>
            <S.Outer>
                <S.Inner>
                    <S.Flex>
                        <S.Card>
                            <Heading tag="h1" $noMargin>{title}</Heading>
                            <Text>{text}</Text>
                        </S.Card>
                    </S.Flex>

                    <S.StyledSlider {...settings}>
                        {data?.map(item => (
                            <S.Image key={item.id} src={item.image} />
                        ))}
                    </S.StyledSlider>
                </S.Inner>
            </S.Outer>

            <svg viewBox="0 0 500 40" preserveAspectRatio="none">
                <path d="M0 40 0 0Q250 40 500 0L500 40Z" fill="#fcfcfc" />
            </svg>
        </S.StyledAtmosphericHero>
    )
}

export default AtmosphericHero